import { LBSwitch, LBButton } from '@linearb/buzz';
import AppRouter from 'common/AppRouter';
import { Link } from 'react-router-dom';

const TeamInsightsSettings = ({
  teamSettings,
  selectedTeam,
  isVisionNotificationsEnabledForTeam,
  updateTeamInsightSettings
}) => {
  const selectedTeamId = selectedTeam.id;
  const isSlackTeamChannelConnected = teamSettings
    ? teamSettings[selectedTeamId]?.slackChannel
    : false;
  const isMSTeamsChannelConnected = teamSettings
    ? teamSettings[selectedTeamId]?.msTeamsChannel
    : false;
  const isTeamChannelSet =
    isSlackTeamChannelConnected || isMSTeamsChannelConnected;

  return (
    <div className='flex flex-col pt-6'>
      <h3 className='text-base font-medium uppercase text-neutral-800'>
        Team Insights Settings
      </h3>

      <div className='flex flex-row pt-4'>
        <div className='pr-2'>
          <LBSwitch
            checked={isVisionNotificationsEnabledForTeam}
            onCheckedChange={updateTeamInsightSettings}
            id='vision-insights-switch'
            data-testid='vision-insights-switch'
            disabled={!isTeamChannelSet}
          />
        </div>

        <div>
          <label htmlFor='vision-insights-switch'>
            <span className='text-base font-medium text-neutral-800'>
              AI Iteration Summary Notification
            </span>
          </label>
        </div>
      </div>

      <p className='ml-11 text-sm font-normal text-neutral-800'>
        Receive an AI-generated iteration summary to your team channel.
      </p>

      {!isSlackTeamChannelConnected && !isMSTeamsChannelConnected && (
        <p className='ml-11 pt-5 text-sm font-normal text-neutral-800'>
          {!isSlackTeamChannelConnected ? (
            <LBButton asChild>
              <Link to={AppRouter.SLACK.path}>Connect your team channel</Link>
            </LBButton>
          ) : (
            <LBButton asChild>
              <Link to={AppRouter.MSTEAMS.path}>Connect your team channel</Link>
            </LBButton>
          )}
          &nbsp;&nbsp;to start receiving AI iteration summary notifications
        </p>
      )}
    </div>
  );
};

export default TeamInsightsSettings;
